import type { ModuleTagEntry } from './index';

/** SOP Common module tags. */
export const tags: ModuleTagEntry[] = ['SOPInstanceUID', 'SOPClassUID'];
